<template>
    <div class="table-area">
        <div class="table-wrapper">
            <div v-if="!isEmpty(totalLog)" class="col-4">
                <!-- {{ totalLog ?? "empty totallog" }} -->
                <div style="display: flex; width: 100%; justify-content: space-between">
                    <div class="d-flex">
                        <span class="section-title">{{ "원시 데이터" }}</span>
                        <b-dropdown left variant="link" no-caret toggle-class="text-dark" menu-class="mt-2">
                            <template #button-content>
                                <span class="badge" style="cursor: pointer">
                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                    <span class="selected-filter-text ml-1">{{ selectedFilterText }}</span>
                                </span>
                            </template>

                            <b-dropdown-item @click="selectFilter('전체', 'total')">전체</b-dropdown-item>
                            <b-dropdown-item @click="selectFilter('보정', 'isCorrected')">보정</b-dropdown-item>
                            <b-dropdown-item @click="selectFilter('미보정', null)">미보정</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(totalLogStartDt) ?? "-"} ~ 
                                ${formatTimeOrDate(totalLogEndDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>
                        <div class="dataDownloadIcon" @click="animate($event, 'flagRawDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <TotalLogDataTable
                    :totalLog="originData"
                    :flagRawDownload="flagRawDownload"
                    :tableRowColor="tableRowColor"
                />
            </div>
            <div v-if="!isEmpty(fiveMinData)" class="col-3">
                <div style="display: flex; width: 100%; justify-content: space-between">
                    <span class="section-title">{{ "5분 데이터" }}</span>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(fiveMinData[0].regDt) ?? "-"} ~ 
                                ${formatTimeOrDate(fiveMinData[fiveMinData.length - 1].regDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>

                        <div class="dataDownloadIcon" @click="animate($event, 'flagFiveminDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <FiveMinDataTable
                    :fiveMinData="fiveMinData"
                    :flagFiveminDownload="flagFiveminDownload"
                    :tableRowColor="tableRowColor"
                />
            </div>
            <div v-if="!isEmpty(fiftyMinData)" class="col-3">
                <div style="display: flex; width: 100%; justify-content: space-between">
                    <span class="section-title">{{ "15분 데이터" }}</span>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(fiftyMinData[0].regDt) ?? "-"} ~ 
                                ${formatTimeOrDate(fiftyMinData[fiftyMinData.length - 1].regDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>

                        <div class="dataDownloadIcon" @click="animate($event, 'flagfiftyMinDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <FiftyMinDataTable
                    :fiftyMinData="fiftyMinData"
                    :flagfiftyMinDownload="flagfiftyMinDownload"
                    :tableRowColor="tableRowColor"
                />

                <div style="display: flex; width: 100%; justify-content: space-between">
                    <span class="section-title">{{ "1시간 데이터" }}</span>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(dailyData[0].regDt) ?? "-"} ~ 
                            ${formatTimeOrDate(dailyData[dailyData.length - 1].regDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>

                        <div class="dataDownloadIcon" @click="animate($event, 'flaghourDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <HourDataTable :hourData="hourData" :flaghourDownload="flaghourDownload" />
            </div>
            <div v-if="!isEmpty(hourData)" class="col-2">
                <div style="display: flex; width: 100%; justify-content: space-between">
                    <span class="section-title">{{ "일 데이터" }}</span>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(dailyData[0].regDt) ?? "-"} ~ 
                                ${formatTimeOrDate(dailyData[dailyData.length - 1].regDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>

                        <div class="dataDownloadIcon" @click="animate($event, 'flagDayDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <DailyDataTable :dailyData="dailyData" :flagDayDownload="flagDayDownload" />

                <div style="display: flex; width: 100%; justify-content: space-between">
                    <span class="section-title">{{ "월 데이터" }}</span>
                    <div class="rightWrapper">
                        <span class="regDt">
                            {{
                                `${formatTimeOrDate(monthData[0].regDt) ?? "-"} ~ 
                            ${formatTimeOrDate(monthData[monthData.length - 1].regDt) ?? "-"}`
                            }}
                        </span>
                        <div class="split"></div>

                        <div class="dataDownloadIcon" @click="animate($event, 'flagMonthDownload')">
                            <i ref="forwardIcon" class="material-icons forwardIcon"> forward </i>
                            <i class="material-icons removeIcon"> remove </i>
                        </div>
                    </div>
                </div>
                <MonthDataTable :monthData="monthData" :flagMonthDownload="flagMonthDownload" />
            </div>
        </div>
    </div>
</template>

<script>
import FiveMinDataTable from "./FiveMinDataTable.vue";
import FiftyMinDataTable from "./FiftyMinDataTable.vue";
import HourDataTable from "./HourDataTable.vue";
import DailyDataTable from "./DailyDataTable.vue";
import MonthDataTable from "./MonthDataTable.vue";
import TotalLogDataTable from "./TotalLogDataTable.vue";
import moment from "moment";

export default {
    props: {
        hourData: { type: Array, default: () => [] },
        fiftyMinData: { type: Array, default: () => [] },
        fiveMinData: { type: Array, default: () => [] },
        dailyData: { type: Array, default: () => [] },
        monthData: { type: Array, default: () => [] },
        totalLog: { type: Array, default: () => [] },
    },
    components: {
        FiveMinDataTable,
        FiftyMinDataTable,
        HourDataTable,
        DailyDataTable,
        MonthDataTable,
        TotalLogDataTable,
    },
    data() {
        return {
            flagRawDownload: false,
            flagFiveminDownload: false,
            flagfiftyMinDownload: false,
            flagDayDownload: false,
            flaghourDownload: false,
            flagMonthDownload: false,
            tableRowColor: ["#FAFBFB", "#E0E0E0", "#BDBDBD", "#9E9E9E"],
            originData: null,
            selectedFilterText: "전체",
            selectedFilterKey: "total",
        };
    },
    watch: {},
    computed: {
        totalLogStartDt() {
            return this.totalLog[0].regDt
                ? moment(this.totalLog[0].regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss")
                : "-";
        },
        totalLogEndDt() {
            return this.totalLog[this.totalLog.length - 1].regDt
                ? moment(this.totalLog[this.totalLog.length - 1].regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss")
                : "-";
        },
    },
    created() {
        this.applyFilter("total");
    },
    mounted() {},
    methods: {
        selectFilter(label, key) {
            this.selectedFilterText = label;
            this.selectedFilterKey = key;
            this.applyFilter(key); // 기존 필터 적용 함수 호출
        },
        applyFilter(type) {
            if (type == "total") {
                this.originData = this.totalLog;
            } else if (type == "isCorrected") {
                this.originData = this.totalLog.filter((item) => item.isCorrected == "Y");
            } else if (type == null) {
                this.originData = this.totalLog.filter((item) => item.isCorrected !== "Y");
            } else {
                this.originData = [];
            }
        },
        formatTimeOrDate(value) {
            if (!value) return "";

            // HH:mm:ss 형식인 경우 → HH:mm 으로 변환
            if (moment(value, "HH:mm:ss", true).isValid()) {
                return moment(value, "HH:mm:ss").format("HH:mm");
            }

            // YYYY-MM-DD 형식인 경우 → MM-DD 으로 변환
            if (moment(value, "YYYY-MM-DD", true).isValid()) {
                return moment(value, "YYYY-MM-DD").format("MM-DD");
            }

            if (moment(value, "YYYY-MM", true).isValid()) {
                return moment(value, "YYYY-MM").format("MM");
            }

            // 유효하지 않은 형식이면 그대로 반환하거나 '' 반환
            return value;
        },
        animate(event, flagName) {
            const icon = event.currentTarget.querySelector(".forwardIcon");
            if (icon) {
                icon.classList.add("shake");
                setTimeout(() => icon.classList.remove("shake"), 600);
            }

            if (flagName in this) {
                this[flagName] = false;
                this.$nextTick(() => {
                    this[flagName] = true;
                });
            } else {
                console.warn(`"${flagName}" does not exist in component data.`);
            }
        },
    },
};
</script>

<style scoped>
.section-title {
    font-size: 12px;
    font-weight: 600;
    background-color: #3c5b6f;
    color: white;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    padding: 2px 20px;
}
.table-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;
}

.table-wrapper {
    display: flex;
    flex: 1;
    /* overflow-y: auto; */
    overflow: hidden;
}
.regDt {
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
}
.forwardIcon {
    transform: rotate(90deg);
}
.dataDownloadIcon {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin: 0 8px 0 1px;
}

.dataDownloadIcon .material-icons {
    font-size: 19px;
    margin: -4px 0;
    user-select: none;
}
@keyframes upDownShake {
    0% {
        transform: rotate(90deg) translateX(0);
    }
    20% {
        transform: rotate(90deg) translateX(-3px);
    }
    40% {
        transform: rotate(90deg) translateX(3px);
    }
    60% {
        transform: rotate(90deg) translateX(-3px);
    }
    80% {
        transform: rotate(90deg) translateX(3px);
    }
    100% {
        transform: rotate(90deg) translateX(0);
    }
}

.shake {
    animation: upDownShake 0.6s ease-in-out;
}
.rightWrapper {
    display: flex;
    justify-content: flex-end;
}
.split {
    border-left: 0.9px solid #eeeeee;
    margin: 1px 5px 1px 9px;
    height: 15px;
}

::v-deep .btn {
    padding: 0px 0px 0px 10px !important;
}

.badge {
    display: inline-block;
    padding: 0px 10px 0px 10px;

    min-width: 20px;
    white-space: nowrap;
    /* background-color: #777; */

    color: #fff;
    /* color: #000; */
    line-height: 20px;
    border-radius: 5px;
    font-size: 11px;
    font-weight: 500;

    text-align: center;
    vertical-align: middle;

    background-color: #78909c;
}
</style>
